import { CollaboratorType } from 'jobs/dtos/job'
import { match } from 'utils/pattern-match-util'

/**
 * Formats the collaborator type to a string
 * @param collaboratorType
 * @returns
 */
export function formatCollaboratorType(collaboratorType: CollaboratorType) {
  return match(collaboratorType, {
    CLIENT: () => 'Client',
    PROVIDER: () => 'Pro',
  })
}

const dateFormatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

const timeFormatter = new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: 'numeric',
  hour12: true,
})

export function formatSentDate(date: Date) {
  return `${dateFormatter.format(date)} at ${timeFormatter.format(date)}`
}
